/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 6L6 9M9 6L12 9M9 6L9 10.6C9 12.8402 9 13.9603 9.43597 14.816C9.81947 15.5686 10.4314 16.1805 11.184 16.564C12.0397 17 13.1598 17 15.4 17H17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M9 6L6 9M9 6L12 9M9 6V9.5C9 11.8297 9 12.9946 9.3806 13.9134C9.88807 15.1386 10.8614 16.1119 12.0866 16.6194C13.0054 17 14.1703 17 16.5 17V17H17.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.53027 5.46967C9.23738 5.17678 8.7625 5.17678 8.46961 5.46967L5.46961 8.46967C5.17672 8.76256 5.17672 9.23744 5.46961 9.53033C5.7625 9.82322 6.23738 9.82322 6.53027 9.53033L8.24994 7.81066V10.6V10.633V10.633C8.24993 11.7252 8.24993 12.5906 8.30693 13.2883C8.36521 14.0017 8.48682 14.6053 8.76766 15.1565C9.22306 16.0502 9.94971 16.7769 10.8435 17.2323C11.3947 17.5131 11.9983 17.6347 12.7117 17.693C13.4093 17.75 14.2747 17.75 15.3669 17.75H15.3669H15.3999H17C17.4142 17.75 17.75 17.4142 17.75 17C17.75 16.5858 17.4142 16.25 17 16.25H15.3999C14.2675 16.25 13.4632 16.2494 12.8338 16.198C12.2132 16.1473 11.8289 16.0509 11.5245 15.8958C10.9129 15.5842 10.4158 15.087 10.1042 14.4755C9.94903 14.171 9.85265 13.7867 9.80195 13.1661C9.75052 12.5367 9.74994 11.7325 9.74994 10.6V7.81066L11.4696 9.53033C11.7625 9.82322 12.2374 9.82322 12.5303 9.53033C12.8232 9.23744 12.8232 8.76256 12.5303 8.46967L9.53027 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 22H9V22C7.13872 22 6.20808 22 5.45492 21.7553C3.93273 21.2607 2.73931 20.0673 2.24472 18.5451C2 17.7919 2 16.8613 2 15V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V15C22 16.8613 22 17.7919 21.7553 18.5451C21.2607 20.0673 20.0673 21.2607 18.5451 21.7553C17.7919 22 16.8613 22 15 22V22H14.5M9 6L6 9M9 6L12 9M9 6V9.5C9 11.8297 9 12.9946 9.3806 13.9134C9.88807 15.1386 10.8614 16.1119 12.0866 16.6194C13.0054 17 14.1703 17 16.5 17V17H17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 6L6 9M9 6L12 9M9 6V9.5C9 11.8297 9 12.9946 9.3806 13.9134C9.88807 15.1386 10.8614 16.1119 12.0866 16.6194C13.0054 17 14.1703 17 16.5 17V17H17.0001M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L12.5303 8.46967C12.8232 8.76256 12.8232 9.23744 12.5303 9.53033C12.2374 9.82322 11.7626 9.82322 11.4697 9.53033L9.75 7.81066V10.6C9.75 11.7325 9.75058 12.5367 9.80201 13.1661C9.85271 13.7867 9.94909 14.171 10.1042 14.4755C10.4158 15.087 10.913 15.5842 11.5245 15.8958C11.829 16.0509 12.2133 16.1473 12.8339 16.198C13.4633 16.2494 14.2675 16.25 15.4 16.25H17.0001C17.4143 16.25 17.7501 16.5858 17.7501 17C17.7501 17.4142 17.4143 17.75 17.0001 17.75H15.4H15.367C14.2748 17.75 13.4094 17.75 12.7117 17.693C11.9983 17.6347 11.3947 17.5131 10.8435 17.2323C9.94978 16.7769 9.22312 16.0502 8.76772 15.1565C8.48688 14.6053 8.36527 14.0017 8.30699 13.2883C8.24999 12.5906 8.25 11.7251 8.25 10.633V10.6L8.25 7.81066L6.53033 9.53033C6.23744 9.82322 5.76256 9.82322 5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967L8.46967 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
